;(function ($, global, GsBase) {
	if($("#confirmFlg").val() === "false"){
		var captchaFlg = $("#captchaFlg").val();
		if(captchaFlg === "true"){
			gs.captchaShow();
			$("#noti_confirmNumber_msg").parent().addClass("error");
			$("#noti_confirmNumber_msg").html("보안문자를 정확하게 입력해주세요.");
		}else{
			alert("보안문자를 정확하게 입력해주세요.");
			location.href = "/cust/login/logout.gs?returnurl=/cust/login/login.gs";
		}
    }
    else if($("#loginFailFlg").val() === "Y"){
//       아이디/패스워드가 불일치시 경고메세지 표시
        var notiMsg = "아이디 또는 비밀번호를 다시 확인하세요.";
        var failCnt = $("#failCnt").val();
        if(isNaN(failCnt)){
        	failCnt = 0;
        }
    	if(failCnt >= 3){
    		notiMsg = "아이디 또는 비밀번호가 틀렸습니다.<br>아이디/비밀번호 찾기를 사용해 보세요~";
    	}
//        
        $("#noti_passwd_msg").parent().addClass("error");
        $("#noti_passwd_msg").html(notiMsg);
    }
	
	var layerReturn = function(){
		var msg = $("#srchLayer #alertMessage").val();
		if(msg){
			if(!alert(msg)){
				var srchLayer = new GsBase.modal('#srchLayer');
				srchLayer.remove();
			}
			
		}
	}
	
	if($("#gsPwChgLayer").val() === "Y"){
		global.logLseq("416205");
		var srchLayer = new GsBase.modal('#srchLayer');
		srchLayer.ajax('/cust/pwSrch/popup/pwSrchMain.gs?isLayer=Y&mode=passwdforcechg&encid='+$("#encid").val(),'#srchLayer',layerReturn);
		
	}
	
	//비밀번호변경레이어오픈
	GsBase.pwdChgLayer = (function(){
		
		var $el = $('#srchLayer');
		var open = function(){
			ajaxCall();
		};
		
		var ajaxCall = function(){
			
			$.ajax({
	    		
				type : "get",
				url  : '/cust/pwSrch/popup/pwChgMailCert.gs?isLayer=Y&authKey='+$("#authKey").val(),
				
			}).done(function(data){
				
				if(!data || data.webError ){
					alert('서비스가 원활하지 않습니다.\n잠시후 다시 시도해 주세요.');
					return;
				}
				
				$el.html(data);
				
				callbackfn(data);
				
			}).fail(function() { 
				
				alert('서비스가 원활하지 않습니다.\n잠시후 다시 시도해 주세요.');
			});//$.ajax
		};
		
		var callbackfn = function(data){
			
			//알럿처리
			if(data.indexOf('alertMessage') > -1){
				var msg = $("#srchLayer #alertMessage").val();
				msg = msg.replace('<br/>','\n').replace('<br>','\n');
				alert(msg);
				
			}else{
				//이후 프로세스가 있다면 공통모달로 처리
				var srchLayer = new GsBase.modal('#srchLayer');
				srchLayer.show($el, null);
			}
		};
		
		return {
			open : open,
		};
	})();
	
	//비밀번호변경레이어오픈 
	if($("#pwChgLayer").val() === "Y"){
//		var srchLayer = new GsBase.modal('#srchLayer');
//		srchLayer.ajax('/cust/pwSrch/popup/pwChgMailCert.gs?isLayer=Y&authKey='+$("#authKey").val(),'#srchLayer',layerReturn);
		GsBase.pwdChgLayer.open();
	}
	
}) (jQuery, window, window.GsBase = window.GsBase || {});

//function test(msg){
//	alert("test"+msg);
//	var srchLayer = new GsBase.modal('#srchLayer');
//	console.log(srchLayer);
//}